export default "__VITE_ASSET__64UCbCHu__"